const fiocTC = require('../../fioc/fiocTC.js');

module.exports = {
    title: 'contractsView-yourActivityTitle',
    subtitle: 'contractsView-yourActivitySubTitle',
    description: 'profileFioc-formStepSubtitle',
    descriptionBold: true,
    order: 1,
    footer_text: '',
    position: 'first',
    components: [fiocTC()],
};